/* Rows are stored under the resource key the database holds — `${workflowId}:${stepId}`, since a
   step id is unique only inside its workflow. This is the one place that encoding is read. */
const findWorkflowStepTask = (tasks, { workflowId, stepId } = {}) => {
  const key = `${String(workflowId || '').trim()}:${String(stepId || '').trim()}`;

  if (key === ':') {
    return null;
  }

  return tasks.find((task) => task?.resourcePrimaryKey === key) || null;
};

export default findWorkflowStepTask;
